import { useState, useEffect } from "react";
import { fetchAuthImage } from "./authImage";

export const useAuthImage = (photoId) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!photoId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchAuthImage(photoId)
      .then((blobUrl) => {
        if (!cancelled) {
          setImageSrc(blobUrl);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [photoId]);

  return { imageSrc, loading, error };
};
